import { useEffect, useState } from 'react';
import { useMutation } from '@apollo/client';

import {
  SET_ON_CONTINUE,
  SET_LOADING,
  SET_SUCCESS,
} from '../../reducers/actionReducer';
import LoadingSpinner from '../LoadingSpinner';
import ErrorText from '../ErrorText';
import { REQUEST_CUSTOM_PLAN } from '../../mutations';
import TextArea from '../inputs/TextArea';

export default function RequestCustomPlan({ dispatchAction }) {
  const [editorState, setEditorState] = useState('');

  const [requestCustomPlan, { loading, error, called, data }] =
    useMutation(REQUEST_CUSTOM_PLAN);

  useEffect(() => {
    if (requestCustomPlan) {
      dispatchAction({
        type: SET_ON_CONTINUE,
        payload: {
          onContinue: () =>
            requestCustomPlan({
              variables: {
                message: editorState,
              },
            }),
        },
      });
    }
  }, [dispatchAction, requestCustomPlan, editorState]);

  useEffect(() => {
    if (loading !== undefined) {
      dispatchAction({
        type: SET_LOADING,
        payload: { loading },
      });
    }
  }, [dispatchAction, loading]);

  useEffect(() => {
    if (called && data && !error) {
      dispatchAction({
        type: SET_SUCCESS,
        payload: {
          message: 'Your request has been sent!',
        },
      });
    }
  }, [called, data, dispatchAction, error]);

  return (
    <div className="flex flex-col justify-center items center text-center space-y-4 w-full px-24">
      {loading && <LoadingSpinner message="Submitting your request..." />}
      {error && <ErrorText message={error.message} />}
      {!loading && !error && (
        <>
          <p>Tell us what you need:</p>
          <TextArea
            value={editorState}
            onChange={(e) => setEditorState(e.target.value)}
            height="72"
          />
        </>
      )}
    </div>
  );
}
